import React from 'react';
import './HowItWorksSection.css';

const HowItWorksSection: React.FC = () => {
  return (
    <section className="how-it-works-section">
      <h2>How It Works</h2>
      <div className="steps-grid">
        <div className="step-item">
          <div className="step-icon-placeholder"></div>
          <h3>Create and Manage Checklists</h3>
          <p>Easily create, organize, and manage all your checklists and their associated tasks.</p>
        </div>
        <div className="step-item">
          <div className="step-icon-placeholder"></div>
          <h3>Complete Tasks and Track Progress</h3>
          <p>Mark tasks as complete and monitor your progress in real-time across all your checklists.</p>
        </div>
        <div className="step-item">
          <div className="step-icon-placeholder"></div>
          <h3>Generate Reports and Gain Insights</h3>
          <p>Upload completed checklists to generate reports and gain valuable insights into your operations.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
